import React, {Component} from 'react';
import {Button} from "primereact/button";

export default class NotFound extends Component {

	render() {
		return <div className="exception-body notfound">
			<div className="exception-text">
				<span className="notfound-text">Chiral Systems Patient Portal</span>
			</div>
			<div className="exception-panel">
				<div className="exception-image">
					<img src="/src/images/exception/icon-error.png" alt="avalon-react"/>
				</div>
				<div className="exception-panel-content">
					<div className="information-text">
						<p>If you are a patient trying to access your practice's online portal, please contact them for the correct web address</p>
					</div>
					<Button label="Chiral Systems Ltd" onClick={() => {window.location = "http://www.chiralsystems.com"}} />
				</div>
			</div>
		</div>
	}
}